<template>
    <div class="customer-group-subcustomer-order-form">
        <keep-alive>
            <CartOrderForm
                v-if="currentForm === 'page-1'"
                :customer="order.customer"
                :order="order"
                :ordered-products="orderedProducts"
                :products-action="productsAction"
                :use-local-storage="true"
                @back="onClickBackPage1"
                @submit="onSubmitPage1"
            />
        </keep-alive>
        <keep-alive>
            <CustomerGroupSubcustomerOrderFormPage2
                v-if="currentForm === 'page-2'"
                :order="order"
                :ordered-products="orderedProducts"
                :categoriesMainCategory="categoriesMainCategory"
                :categoriesById="categoriesById"
                :action="action"
                @back="onClickBackPage2"
            />
        </keep-alive>
    </div>
</template>

<script>
import CartOrderForm from "./CartOrderForm"
import CustomerGroupSubcustomerOrderFormPage2 from "./CustomerGroupSubcustomerOrderForm/CustomerGroupSubcustomerOrderFormPage2"

export default {
    components: {
        CartOrderForm,
        CustomerGroupSubcustomerOrderFormPage2,
    },

    props: {
        categoriesMainCategory: {
            type: Object,
            required: true,
        },
        categoriesById: {
            type: Object,
            required: true,
        },
        order: {
            type: Object,
            required: false,
        },
        action: {
            type: String,
            required: true,
        },
        productsAction: {
            type: String,
            required: false,
        },
        backUrl: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            currentForm: 'page-1',
            orderedProducts: null,
        }
    },

    /*
    created() {
        window.addEventListener('beforeunload', this.showQuitAlert);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.showQuitAlert);
    },
    */

    methods: {
        /*
        showQuitAlert(e) {
            // Cancel the event
            e.preventDefault();
            // Chrome requires returnValue to be set
            e.returnValue = '';
        },
        */

        onClickBackPage1() {
            location = this.backUrl;
        },

        onSubmitPage1(data) {
            this.orderedProducts = data.cartProducts;
            this.currentForm = 'page-2';
        },

        onClickBackPage2() {
            this.currentForm = 'page-1';
        },
    },
}
</script>
